<template>
  <div class="aside-menu flex-column-fluid">
    <div id="kt_aside_menu_wrapper"
         class="hover-scroll-overlay-y my-2 my-lg-2"
         data-kt-scroll="true"
         data-kt-scroll-activate="{default: false, lg: true}"
         data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
         data-kt-scroll-height="auto"
         data-kt-scroll-offset="0"
         data-kt-scroll-wrappers="#kt_aside_menu">
      <div id="#kt_aside_menu"
           class="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 menu-compact"
           data-kt-menu="true" data-kt-menu-expand="false"
           @click="closeDrawerOnMobile">

        <!-- Accueil : remplace le tableau de bord pour qui n'y a pas accès -->
        <div class="menu-item" v-if="!$can('dashboard_view')">
          <router-link class="menu-link" :class="{ 'active': $route.name === 'home' }" :to="{ name: 'home' }">
            <span class="menu-icon-wrapper icon-primary"><i class="bi bi-house-door"></i></span>
            <span class="menu-title">{{ $t('navigation.home') }}</span>
          </router-link>
        </div>

        <!-- Menu principal -->
        <div class="menu-item" v-for="(menuItems, index) in menuPrincipal" :key="'principal-'+index">
          <router-link
            v-if="$accessMenu(menuItems.permission) && (!menuItems.module || $hasModule(menuItems.module))"
            class="menu-link"
            :class="{ 'active': activateUrl(menuItems.group) }"
            :to="menuItems.route"
          >
            <span :id="menuItems?.id" class="menu-icon-wrapper" :class="[menuItems.iconClass, { 'menu-icon-wrapper--alert': menuItems.alert }]">
              <i :class="[menuItems.icon]"></i>
              <!-- Boutiques : rupture, transfert à valider ou crédit en retard dans au moins une boutique -->
              <span v-if="menuItems.alert === 'shops' && hasShopAlerts" class="menu-alert-dot menu-alert-dot--icon"></span>
            </span>
            <span class="menu-title">{{ menuItems.title }}</span>
          </router-link>
        </div>

        <!-- Séparateur léger -->
        <div class="menu-separator"></div>

        <!-- Menu commercial -->
        <div class="menu-item" v-for="(menuItems, index) in menuCommercial" :key="'commercial-'+index">
          <router-link
            v-if="$accessMenu(menuItems.permission) && (!menuItems.module || $hasModule(menuItems.module))"
            class="menu-link"
            :class="{ 'active': activateUrl(menuItems.group) }"
            :to="menuItems.route"
          >
            <span :id="menuItems?.id" class="menu-icon-wrapper" :class="menuItems.iconClass">
              <i :class="[menuItems.icon]"></i>
            </span>
            <span class="menu-title">{{ menuItems.title }}</span>
          </router-link>
        </div>

        <!-- Mes Livraisons (standalone — livreur) -->
        <div class="menu-item" v-if="$can('delivery_view') && $hasModule('ecommerce')">
          <router-link
            class="menu-link"
            :class="{ 'active': activateUrl(myDeliveries) }"
            :to="'/admin/ecommerce/my-deliveries'"
          >
            <span class="menu-icon-wrapper icon-warning">
              <i class="bi bi-bicycle"></i>
            </span>
            <span class="menu-title">{{ $t('navigation.my_deliveries') }}</span>
          </router-link>
        </div>

        <!-- Séparateur léger -->
        <div class="menu-separator" v-if="($can('order_view') || $can('all_deliveries_view') || $can('rating_view')) && $hasModule('ecommerce')"></div>

        <!-- E-commerce (Accordion) -->
        <div class="menu-item menu-accordion" data-kt-menu-trigger="click" v-if="($can('order_view') || $can('all_deliveries_view') || $can('rating_view') || $can('product_view')) && $hasModule('ecommerce')">
          <span class="menu-link">
            <span id="step-commandes" class="menu-icon-wrapper icon-primary menu-icon-wrapper--alert">
              <i class="bi bi-cart3"></i>
              <!-- Commandes en attente / avis « Non publié » : visible même menu replié / sous-menu fermé -->
              <span v-if="(pendingOrdersCount > 0 && $can('order_view')) || (offlineReviewsCount > 0 && $can('rating_view'))" class="menu-alert-dot menu-alert-dot--icon"></span>
            </span>
            <span class="menu-title">{{ $t('navigation.e-commerce') }}</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <div class="menu-item" v-if="$can('product_view')">
              <router-link class="menu-link" :class="{ 'active': activateUrl(ecommerceCatalogue) }" :to="'/admin/ecommerce/catalogue'">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.ecommerce_catalogue') }}</span>
              </router-link>
            </div>
            <div class="menu-item" v-if="$can('order_view')">
              <router-link class="menu-link" :class="{ 'active': activateUrl(commandes) }" :to="'/admin/ecommerce/orders'">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.e-commerce_commandes') }}</span>
                <!-- Commandes « En attente traitement » : point rouge clignotant -->
                <span v-if="pendingOrdersCount > 0" class="menu-alert-dot"></span>
              </router-link>
            </div>
            <div class="menu-item" v-if="$can('all_deliveries_view')">
              <router-link class="menu-link" :class="{ 'active': activateUrl(allDeliveries) }" :to="'/admin/ecommerce/deliveries'">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.all_deliveries') }}</span>
              </router-link>
            </div>
            <div class="menu-item" v-if="$can('rating_view')">
              <router-link class="menu-link" :class="{ 'active': activateUrl(reviews) }" :to="'/admin/ecommerce/reviews'">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.e-commerce_review') }}</span>
                <!-- Avis « Non publié » en attente : point rouge clignotant -->
                <span v-if="offlineReviewsCount > 0" class="menu-alert-dot"></span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- POS (Accordion) -->
        <div class="menu-item menu-accordion" data-kt-menu-trigger="click" v-if="$can('session_view') || $can('sale_boutique_view')">
          <span class="menu-link">
            <span id="step-pos" class="menu-icon-wrapper icon-warning">
              <i class="bi bi-display"></i>
            </span>
            <span class="menu-title">{{ $t('navigation.pos') }}</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <div class="menu-item" v-if="$can('session_view')">
              <router-link class="menu-link" :class="{ 'active': activateUrl(posSessions) }" :to="{ name: 'pos-session-path' }">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.pos_sessions') }}</span>
              </router-link>
            </div>
            <div class="menu-item" v-if="$can('sale_boutique_view')">
              <router-link class="menu-link" :class="{ 'active': activateUrl(posSales) }" :to="{ name: 'pos-sales-path' }">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.pos_sales') }}</span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Statistiques (Accordion) -->
        <div v-if="$can('statistic_view')" class="menu-item menu-accordion" data-kt-menu-trigger="click">
          <span class="menu-link">
            <span id="step-statistique" class="menu-icon-wrapper icon-info">
              <i class="bi bi-bar-chart-line"></i>
            </span>
            <span class="menu-title">{{ $t('navigation.statistique') }}</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <div class="menu-item">
              <router-link class="menu-link" :class="{ 'active': activateUrl(statistiqueVente) }" :to="'/admin/statistique/sale'">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.statistique_sale') }}</span>
              </router-link>
            </div>
            <div class="menu-item">
              <router-link class="menu-link" :class="{ 'active': activateUrl(statistiqueCategory) }" :to="'/admin/statistique/products'">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.statistique_category') }}</span>
              </router-link>
            </div>
            <div class="menu-item">
              <router-link class="menu-link" :class="{ 'active': activateUrl(statistiqueUser) }" :to="'/admin/statistique/user'">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.statistique_user') }}</span>
              </router-link>
            </div>
            <div class="menu-item" v-if="$hasModule('pos.stock')">
              <router-link class="menu-link" :class="{ 'active': activateUrl(statistiqueRentabilite) }" :to="'/admin/statistique/rentabilite'">
                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                <span class="menu-title">{{ $t('navigation.statistique_rentabilite') }}</span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Rapports -->
        <div v-if="$hasModule('reports') && $can('report_view')" class="menu-item">
          <router-link class="menu-link" :class="{ 'active': activateUrl(rapportsHub) }" :to="{ name: 'rapports-hub-path' }">
            <span id="step-rapports" class="menu-icon-wrapper icon-info">
              <i class="bi bi-file-earmark-bar-graph"></i>
            </span>
            <span class="menu-title">{{ $t('report.hub_title') }}</span>
          </router-link>
        </div>

        <!-- Séparateur léger -->
        <div class="menu-separator"></div>

        <!-- Paramètres -->
        <div class="menu-item">
          <router-link
            v-if="$can('setting_view')"
            class="menu-link"
            :class="{ 'active': activateUrl(settings) }"
            :to="'/admin/settings'"
          >
            <span id="step-settings" class="menu-icon-wrapper icon-dark">
              <i class="bi bi-gear"></i>
            </span>
            <span class="menu-title">{{ $t('navigation.setting') }}</span>
          </router-link>
        </div>

      </div>
    </div>
  </div>

  <!-- Footer compact -->
  <div class="aside-footer flex-column-auto py-4 px-4" id="kt_aside_footer">
<!--    <div class="footer-compact">-->
<!--      <a href="#" id="voir-guide" class="footer-icon-btn" data-bs-toggle="tooltip" :title="$t('introjsBulle.help')">-->
<!--        <i class="bi bi-question-circle"></i>-->
<!--      </a>-->
<!--      <a href="#" class="footer-icon-btn" data-bs-toggle="tooltip" title="Documentation">-->
<!--        <i class="bi bi-book"></i>-->
<!--      </a>-->
<!--    </div>-->
    <documentation-menu></documentation-menu>
  </div>
</template>

<script setup>
import i18n from '@/plugins/i18n';
import { computed, onBeforeUnmount, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from "vuex";
import DocumentationMenu from './DocumentationMenu.vue'

const closeDrawerOnMobile = (event) => {
  // Fermer uniquement si le clic vient d'un vrai lien de navigation (router-link → <a>)
  // Les toggles d'accordéon sont des <span class="menu-link">, pas des <a>
  if (!event.target.closest('a.menu-link')) return
  const asideEl = document.getElementById('kt_aside')
  if (!asideEl) return
  const drawer = window.KTDrawer?.getInstance(asideEl)
  if (drawer && drawer.isShown()) {
    drawer.hide()
  }
}

const store = useStore()
const route = useRoute()

// Groupes de routes pour l'activation
const dashboard = ['dashboard', 'dashboard-path']
const statistiqueVente = ['statistique-sale-path']
const statistiqueUser = ['statistique-user-path']
const statistiqueCategory = ['statistique-category-path']
const statistiqueRentabilite = ['statistique-rentabilite-path']
const rapportsHub = ['rapports-hub-path', 'rapports-viewer-path']
const code_promo = ['code-promo-index']
const contacts = ['contacts-path', 'contact-view-path']
const promotions = ['promotions', 'promotion-view', 'promotion-detail']
const loyalty = ['loyalty-programs', 'loyalty-program-detail', 'loyalty-members', 'loyalty-member-detail']
const suppliersPurchases = ['suppliers-purchases', 'suppliers-purchases-create', 'suppliers-purchases-edit', 'suppliers-purchases-view', 'suppliers-purchases-validate']
const commandes = ['ecommerce-commandes-path', 'ecommerce-destockage-path']
const ecommerceCatalogue = ['ecommerce-catalogue-path']
const myDeliveries = ['ecommerce-my-deliveries']
const allDeliveries = ['ecommerce-all-deliveries']
const reviews = ['review-path']
const productsEcommerce = ['products-path']
const storesGroup = [
  'settings-stores', 'store-data-path', 'store-entries-create',
  'store-output-create', 'store-output-content', 'store-details', 'store-details-product',
  'store-details-entries', 'store-details-output', 'store-details-user', 'store-unvalid-entry-view',
  'store-details-unvalide-entry', 'store-details-update'
]
const articlesGroup = ['settings-items', 'settings-items-view', 'settings-lots', 'bundles-path', 'bundle-edit-path', 'bundle-create-path']
const posCaisse = ['pos-caisse-path', 'pos-payment-path', 'pos-order-path']
const posSessions = ['pos-session-path', 'pos-session-create-path', 'pos-session-details-path', 'pos-session-sales-path', 'pos-session-products-path']
const posSales = ['pos-sales-path', 'pos-sales-details-path']
const settings = [
  'settings-new', 'settings-items', 'settings-items-list', 'settings-users',
  'settings-categories', 'settings-attributes', 'settings-product-options', 'settings-product-option-create', 'settings-product-option-edit', 'settings-brands', 'settings-taxes',
  'settings-currencies', 'settings-rights', 'settings', 'settings-items-view',
  'settings-lots', 'settings-rights-view',
  'setting-shipping-areas', 'setting-shipping-areas-view', 'setting-shipping-intervals',
  'setting-shipping-relays', 'setting-shipping-relays-view', 'settings-shipping',
  'setting-shipping-countries', 'society-config', 'setting-system-payment', 'setting-system-currency',
  'setting-system-condition', 'setting-system-media',
  'setting-ecommerce-payment', 'setting-ecommerce-media', 'setting-ecommerce-mediaList',
  'settings-ecommerce'
]

const shopsList = computed(() => store.getters['shop/getShops'] || [])

// Alertes du menu E-commerce : commandes « En attente traitement » et avis « Non publié ».
// Recomptées à l'ouverture, à chaque changement de page, toutes les minutes (une commande
// peut arriver à tout moment) et par le store après une action sur une commande / un avis.
const offlineReviewsCount = computed(() => store.getters['review/getOfflineReviewsCount'] || 0)
const pendingOrdersCount = computed(() => store.getters['ecommerce/getPendingOrdersCount'] || 0)
const hasShopAlerts = computed(() => store.getters['shop/hasShopAlerts'])
const loadMenuAlerts = () => {
  store.dispatch('review/loadOfflineReviewsCount')
  store.dispatch('ecommerce/loadPendingOrdersCount')
  store.dispatch('shop/loadShopAlerts')
}
watch(() => route.name, loadMenuAlerts)
let menuAlertsTimer = null
onBeforeUnmount(() => clearInterval(menuAlertsTimer))

onMounted(() => {
  if (!shopsList.value.length) {
    store.dispatch('shop/fetchShops')
  }
  loadMenuAlerts()
  menuAlertsTimer = setInterval(() => {
    if (!document.hidden) loadMenuAlerts()
  }, 60000)
})

// Configuration du menu principal (Dashboard, Articles, Boutiques)
const menuPrincipal = computed(() => {
  return [
    {
      title: i18n.global.t('navigation.dashboard'),
      icon: 'bi bi-house-door',
      iconClass: 'icon-primary',
      route: '/admin/dashboard',
      group: dashboard,
      permission: ['dashboard_view'],
      id: 'step-dashboard',
    },
    {
      title: i18n.global.t('navigation.catalog'),
      icon: 'bi bi-box-seam',
      iconClass: 'icon-success',
      route: '/admin/settings-product',
      group: articlesGroup,
      id: 'step-articles',
      permission: ['product_view'],
    },
    {
      title: i18n.global.t('navigation.single_shop'),
      icon: 'bi bi-shop',
      iconClass: 'icon-warning',
      route: '/admin/shops',
      group: 'shops',
      id: 'step-shops',
      alert: 'shops',
      permission: ['boutique_view', 'product_boutique_view'],
    },
    {
      // Magasins (société) : stocks, entrées, sorties vers les boutiques — module pos.warehouse
      title: i18n.global.t('navigation.store'),
      icon: 'bi bi-building',
      iconClass: 'icon-info',
      route: '/admin/stores',
      group: storesGroup,
      id: 'step-stores',
      permission: ['magasin_view'],
      module: 'pos.warehouse',
    },
  ]
})

// Configuration du menu commercial (Clients, Promotions, Codes promo, Fournisseurs)
const menuCommercial = computed(() => {
  return [
    {
      title: i18n.global.t('navigation.contact'),
      icon: 'bi bi-people',
      iconClass: 'icon-success',
      route: '/admin/contacts',
      group: contacts,
      id: 'step-contacts',
      permission: ['customer_view'],
    },
    {
      title: i18n.global.t('navigation.promotions'),
      icon: 'bi bi-megaphone',
      iconClass: 'icon-danger',
      route: '/admin/promotions',
      group: promotions,
      id: 'step-promotion',
      permission: ['promotion_view'],
      module: 'ecommerce.promotions',
    },
    {
      title: i18n.global.t('navigation.loyalty'),
      icon: 'bi bi-gift',
      iconClass: 'icon-warning',
      route: '/admin/loyalty-programs',
      group: loyalty,
      id: 'step-loyalty',
      permission: ['loyalty_program_view'],
      module: 'loyalty',
    },
    {
      title: i18n.global.t('navigation.promo'),
      icon: 'bi bi-percent',
      iconClass: 'icon-info',
      route: '/admin/code-promo',
      group: code_promo,
      permission: ['code_promo_view'],
      id: 'step-promo',
      module: 'ecommerce.promo_codes',
    },
    {
      title: i18n.global.t('navigation.suppliers_purchases'),
      icon: 'bi bi-truck',
      iconClass: 'icon-warning',
      route: '/admin/suppliers/purchases',
      group: suppliersPurchases,
      id: 'step-suppliers',
      permission: ['supplier_view'],
      module: 'pos.suppliers',
    },
  ]
})

function activateUrl(group) {
  // Le menu "Boutiques" passe une chaîne ('shops') plutôt qu'un tableau de
  // noms de route car il a trop d'enfants imbriqués (produits, promotions,
  // stock, sessions, commandes...) pour les lister un par un, et certains
  // d'entre eux (session-*, order-details) ne partagent même pas le préfixe
  // "shop-" — seul le préfixe d'URL /admin/shops les couvre tous.
  if (typeof group === 'string') {
    return route.path.startsWith('/admin/' + group)
  }
  return group.includes(route.name)
}
</script>

<style scoped>
/* Point rouge clignotant : quelque chose attend une action (avis non publiés) */
.menu-alert-dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin-left: 6px;
  margin-right: 6px;
  border-radius: 50%;
  background: #f1416c;
  animation: menu-alert-blink 1.1s ease-in-out infinite;
}
/* Variante posée sur le coin de l'icône du menu parent */
.menu-icon-wrapper--alert {
  position: relative;
}
.menu-alert-dot--icon {
  position: absolute;
  top: -3px;
  right: -3px;
  margin: 0;
  border: 1.5px solid #fff;
  width: 10px;
  height: 10px;
}
@keyframes menu-alert-blink {
  0%, 100% {
    opacity: 1;
    box-shadow: 0 0 0 0 rgba(241, 65, 108, 0.55);
  }
  50% {
    opacity: 0.25;
    box-shadow: 0 0 0 5px rgba(241, 65, 108, 0);
  }
}

/* Compact menu */
.menu-compact .menu-item {
  margin: 0;
}

.menu-compact .menu-link {
  padding: 6px 10px;
}

/* Séparateur ultra léger */
.menu-separator {
  height: 1px;
  background: rgba(var(--kt-primary-rgb), 0.15);
  margin: 4px 20px;
}

/* Menu icon avec fond coloré */
.menu-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  margin-right: 10px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  font-size: 0.95rem;
}

/* Icônes : une seule couleur (celle de la boutique) pour tout le menu, comme l'accueil ;
   les classes icon-* restent sur les entrées mais ne changent plus la couleur */
.icon-primary,
.icon-success,
.icon-warning,
.icon-danger,
.icon-info,
.icon-dark {
  background-color: rgba(var(--kt-primary-rgb), 0.12);
  color: var(--kt-primary);
}

/* le thème grise les <i> du menu : l'icône prend la couleur de son cadre */
.menu-icon-wrapper i {
  color: inherit !important;
}

/* Menu link styling */
.menu-link {
  position: relative;
  border-radius: 4px;
  margin: 0 6px;
  transition: all 0.15s ease;
}

.menu-link:hover {
  background-color: rgba(var(--kt-primary-rgb), 0.08);
}

/* Active state */
.menu-link.active {
  background-color: rgba(var(--kt-primary-rgb), 0.1);
}

.menu-link.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 20%;
  width: 3px;
  height: 60%;
  background-color: var(--kt-primary);
  border-radius: 0 2px 2px 0;
}

.menu-link.active .menu-title {
  color: var(--kt-primary);
  font-weight: 600;
}

.menu-link.active .menu-icon-wrapper {
  color: var(--kt-primary) !important;
}

/* Menu title */
.menu-title {
  font-weight: 500;
  font-size: 0.925rem;
  color: #3f4254;
}

/* Accordion arrow */
.menu-accordion .menu-arrow {
  transition: transform 0.2s ease;
}

.menu-accordion.show > .menu-link .menu-arrow,
.menu-accordion.showing > .menu-link .menu-arrow {
  transform: rotate(90deg);
}

/* Sub menu compact */
.menu-sub-accordion {
  padding-left: 34px;
}

.menu-sub-accordion .menu-link {
  padding: 4px 10px;
  margin-left: 0;
}

.menu-sub-accordion .menu-link.active::before {
  display: none;
}

.menu-bullet .bullet-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #b5b5c3;
  transition: all 0.15s ease;
}

.menu-sub-accordion .menu-link:hover .bullet-dot,
.menu-sub-accordion .menu-link.active .bullet-dot {
  background-color: var(--kt-primary);
}

.menu-sub-accordion .menu-title {
  font-size: 0.875rem;
}

/* Footer compact */
.footer-compact {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.footer-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: var(--kt-primary);
  text-decoration: none;
  transition: all 0.15s ease;
  font-size: 1.15rem;
}

.footer-icon-btn i {
  color: #fff;
}

.footer-icon-btn:hover {
  background: var(--kt-primary-active);
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(var(--kt-primary-rgb), 0.3);
}

.footer-icon-btn:hover i {
  color: #fff;
}
</style>
